var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdatedaccountbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 182,
    viewBox: "0 0 182 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_297_2250",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 182,
    height: 182
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 91,
    r: 91,
    fill: "#1E1E1E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_297_2250)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M358.176 80.779C373.73 181.658 363.911 378.761 200.206 360.14C-4.42401 336.862 -314.128 165.759 -545.896 512.309",
    stroke: "url(#paint0_linear_297_2250)",
    strokeWidth: 7.28
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M357.622 58.6976C373.175 159.577 363.356 356.68 199.652 338.058C-4.97869 314.781 -314.682 143.678 -546.451 490.228",
    stroke: "url(#paint1_linear_297_2250)",
    strokeWidth: 7.28
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M357.065 36.6155C372.619 137.495 362.799 334.598 199.095 315.976C-5.53533 292.699 -315.239 121.596 -547.008 468.146",
    stroke: "url(#paint2_linear_297_2250)",
    strokeWidth: 7.28
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M356.51 14.5329C372.064 115.412 362.245 312.515 198.54 293.893C-6.09002 270.616 -315.794 99.5131 -547.562 446.063",
    stroke: "url(#paint3_linear_297_2250)",
    strokeWidth: 7.28
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M355.954 -7.54921C371.507 93.3301 361.688 290.433 197.984 271.811C-6.64666 248.534 -316.35 77.4311 -548.119 423.981",
    stroke: "url(#paint4_linear_297_2250)",
    strokeWidth: 7.28
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M355.399 -29.6314C370.953 71.2479 361.133 268.351 197.429 249.729C-7.20135 226.452 -316.905 55.3489 -548.674 401.899",
    stroke: "url(#paint5_linear_297_2250)",
    strokeWidth: 7.28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.844 -51.7135C370.398 49.1658 360.579 246.269 196.874 227.647C-7.75604 204.37 -317.46 33.2668 -549.228 379.817",
    stroke: "url(#paint6_linear_297_2250)",
    strokeWidth: 7.28
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M354.288 -73.7962C369.841 27.0831 360.022 224.186 196.318 205.564C-8.31268 182.287 -318.016 11.1841 -549.785 357.734",
    stroke: "url(#paint7_linear_297_2250)",
    strokeWidth: 7.28
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M353.733 -95.8776C369.287 5.0017 359.467 202.105 195.763 183.483C-8.86737 160.206 -318.571 -10.8973 -550.34 335.653",
    stroke: "url(#paint8_linear_297_2250)",
    strokeWidth: 7.28
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M353.178 -117.96C368.732 -17.0804 358.913 180.023 195.208 161.401C-9.42205 138.123 -319.126 -32.9794 -550.894 313.57",
    stroke: "url(#paint9_linear_297_2250)",
    strokeWidth: 7.28
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M352.622 -140.042C368.175 -39.1625 358.356 157.941 194.652 139.319C-9.97869 116.041 -319.682 -55.0615 -551.451 291.488",
    stroke: "url(#paint10_linear_297_2250)",
    strokeWidth: 7.28
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M352.067 -162.124C367.621 -61.2446 357.801 135.859 194.097 117.237C-10.5334 93.9592 -320.237 -77.1436 -552.006 269.406",
    stroke: "url(#paint11_linear_297_2250)",
    strokeWidth: 7.28
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M351.51 -184.206C367.064 -83.3267 357.245 113.776 193.54 95.1545C-11.09 71.8771 -320.794 -99.2258 -552.562 247.324",
    stroke: "url(#paint12_linear_297_2250)",
    strokeWidth: 7.28
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_297_2250",
    x1: -449.041,
    y1: 150.84,
    x2: 322.425,
    y2: 357.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B22EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FF1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_297_2250",
    x1: -449.596,
    y1: 128.759,
    x2: 321.87,
    y2: 335.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B22EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FF1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_297_2250",
    x1: -450.152,
    y1: 106.677,
    x2: 321.314,
    y2: 313.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B22EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FF1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_297_2250",
    x1: -450.707,
    y1: 84.5943,
    x2: 320.759,
    y2: 291.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B22EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FF1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_297_2250",
    x1: -451.264,
    y1: 62.5122,
    x2: 320.202,
    y2: 269.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B22EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FF1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_297_2250",
    x1: -451.818,
    y1: 40.43,
    x2: 319.648,
    y2: 247.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B22EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FF1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_297_2250",
    x1: -452.373,
    y1: 18.3479,
    x2: 319.093,
    y2: 225.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B22EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FF1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_297_2250",
    x1: -452.93,
    y1: -3.73481,
    x2: 318.536,
    y2: 202.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B22EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FF1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_297_2250",
    x1: -453.484,
    y1: -25.8162,
    x2: 317.982,
    y2: 180.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B22EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FF1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_297_2250",
    x1: -454.039,
    y1: -47.8983,
    x2: 317.427,
    y2: 158.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B22EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FF1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_297_2250",
    x1: -454.596,
    y1: -69.9804,
    x2: 316.87,
    y2: 136.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B22EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FF1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_297_2250",
    x1: -455.15,
    y1: -92.0625,
    x2: 316.316,
    y2: 114.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B22EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FF1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_297_2250",
    x1: -455.707,
    y1: -114.145,
    x2: 315.759,
    y2: 92.5691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B22EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FF1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatedaccountbg);
export default __webpack_public_path__ + "static/media/updatedaccountbg.f028ef707d56cc3686f5db2323aec888.svg";
export { ForwardRef as ReactComponent };